import React from "react";
import LiveSetup from "../Posts/LiveSetup";
import PostShare from "../PostShare/PostShare";
import "./PostContainer.css";
import { Tab } from "semantic-ui-react";
import { useAuthContext } from "../../Hooks/useAuthContext";
import { useMetaData } from "../../Context/MetaDataContext";
import PostShareModal from "../Modal/PostShareModal";
import { isMobile } from "react-device-detect";
import TradingPlan from "../Posts/TradingPlan";
import MarketInsight from "../Posts/MarketInsight";
import MarketToday from "../Posts/MarketToday";
import CustomTabMenu from "./CustomTabMenu";
import OnlineClass from "../Posts/OnlineClass";


const PostContainer = () => {
  const { user } = useAuthContext();
  const { metaData } = useMetaData();
  const panes = [
    {
      menuItem: {
        key: "markettoday",
        icon: "desktop",
        content: `${metaData.MENU.MARKET_TODAY}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <MarketToday />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "livesetup",
        icon: "chart line",
        content: `${metaData.MENU.LIVE_SETUP}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <LiveSetup />
        </Tab.Pane>
      ),
    },
    {
      // menuItem: "Trading Plan",
      menuItem: {
        key: "tradingplan",
        icon: "idea",
        content: `${metaData.MENU.TRADING_PLAN}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <TradingPlan />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "marketinsight",
        icon: "coffee",
        content: `${metaData.MENU.MARKET_INSIGHT}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <MarketInsight />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "class",
        icon: "book",
        content: `${metaData.MENU.CLASS}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <OnlineClass />
        </Tab.Pane>
      ),
    },
  ];
  return (
    <div className="PostContainer">
      {user && (user.user.isAdmin === true || user.user.role === 1) && (
        <>{!isMobile ? <PostShare /> : <PostShareModal />}</>
      )}
      <div className="market-content-grid">
        <div className="market-tabs-panel">
          <CustomTabMenu panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default PostContainer;
